import { fontSize } from "config/styles/fonts";

const styles = {
  list: {
    "&.MuiList-root": {
      mt: "10px",
    },
    "& .MuiButtonBase-root:first-of-type": {
      borderTop: "1px solid",
      borderTopColor: "background.modalBg",
    },
  },
  innerList: {
    "& .MuiButtonBase-root:first-of-type": {
      borderTop: "unset",
    },
  },
  item: {
    "&.MuiButtonBase-root.MuiListItemButton-root": {
      height: {
        xs: "65px",
        xxl: "80px",
      },
      pr: {
        xs: "16px",
        md: "32px",
      },
    },
  },
  header: {
    p: {
      xs: "20px 16px 0",
      md: "20px 36px 0",
    },
  },
  tariff: {
    "& .MuiTypography-root": {
      fontSize: {
        xs: fontSize.l,
        xxl: "20px",
      },
    },
  },
  costWrap: {
    justifyItems: "self-end",
  },
  orderCost: {
    "&.MuiTypography-root": {
      fontSize: fontSize.xl,
      color: "text.primary",
      fontWeight: 600,
    },
  },
  currency: {
    "&.MuiTypography-root": {
      fontSize: fontSize.m,
      color: "text.primary",
      fontWeight: 600,
    },
  },
  skeletonWrap: {
    mt: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  carIcon: (color: string) => ({
    mr: "20px",
    width: {
      xs: "70px",
      xxl: "100px",
    },
    color: color,
    justifyContent: "center",
  }),
};

export default styles;
